import React from 'react';
import logoMask from '../assets/images/mediablox_outtie.webp';
import '../styles/mediablox-logo.css';

/** Base nav size from mediablox-website (24px wordmark height). */
const BASE_LOGO_HEIGHT = 24;
const BASE_INDICATOR_SIZE = 23;
const BASE_INDICATOR_LEFT = 168;

const logoMaskStyle = {
  WebkitMask: `url(${logoMask}) left center / contain no-repeat`,
  mask: `url(${logoMask}) left center / contain no-repeat`,
};

function getLogoVars(size) {
  const scale = size / BASE_LOGO_HEIGHT;
  return {
    '--mediablox-scale': String(scale),
    '--mediablox-logo-height': `${size}px`,
    '--mediablox-indicator-size': `${BASE_INDICATOR_SIZE * scale}px`,
    '--mediablox-indicator-left': `${BASE_INDICATOR_LEFT * scale}px`,
    '--mediablox-indicator-top': '0px',
  };
}

/**
 * MediaBlox wordmark + holographic indicator — matches main website navigation.
 * @param {number} size — wordmark height in px (default 24); indicator scales with it
 */
const MediaBloxLogo = ({ asLink = false, className = '', href = '/', size = BASE_LOGO_HEIGHT }) => {
  const groupClass = ['nav-logo-group', className].filter(Boolean).join(' ');
  const groupStyle = getLogoVars(size);

  const logoMark = (
    <span
      className="logo-image logo-image--glass"
      style={logoMaskStyle}
      role="img"
      aria-label="MediaBlox"
    />
  );

  return (
    <div className={groupClass} style={groupStyle}>
      <div className="nav-indicator" aria-hidden="true" />
      {asLink ? (
        <a href={href} className="nav-logo" aria-label="MediaBlox">
          {logoMark}
        </a>
      ) : (
        <div className="nav-logo" aria-label="MediaBlox">
          {logoMark}
        </div>
      )}
    </div>
  );
};

export default MediaBloxLogo;
